import { css } from '@emotion/css';

//dashed border ref: https://kovart.github.io/dashed-border-generator/

export const buttonIcon = css`
  width: auto !important;
  height: auto !important;
`;

export const uploadButton = css`
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23BFBFBFFF' stroke-width='2' stroke-dasharray='4' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  padding: 16px 14px;
`;

export const iconStyles = css`
  fill: none;
`;

export const uploadInput = css`
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23999999FF' stroke-width='2' stroke-dasharray='4' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  border: none;
  div {
    opacity: 100% !important;
  }
`;

export const popoverContainer = (isUploadButton?: boolean) => css`
  width: 36rem;
  height: ${isUploadButton ? '29.6rem' : 'auto'};
`;

export const inputStyles = css`
  width: 70%;
`;
